const carouselItems = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20romantic%20manga%20style%20illustration%20of%20two%20characters%20under%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20pink%20and%20golden%20lighting%2C%20dreamy%20atmospheric%20scene%2C%20watercolor%20texture%20feel%2C%20artistic%20Japanese%20manga%20aesthetic%2C%20clean%20composition%20with%20warm%20emotional%20tone%2C%20gentle%20color%20palette%20of%20rose%20and%20cream&width=800&height=500&seq=carousel-01-2026&orientation=landscape",
    title: '都市言情精选',
    desc: '甜虐交织的浪漫故事，每一话都让人心跳加速',
    tag: '韩漫热门',
  },
  {
    img: "https://readdy.ai/api/search-image?query=An%20action%20fantasy%20manga%20illustration%20of%20a%20warrior%20character%20with%20flowing%20cape%20standing%20on%20cliff%20edge%2C%20dramatic%20sky%20with%20warm%20orange%20and%20crimson%20clouds%2C%20epic%20scale%20landscape%20background%2C%20dynamic%20pose%20with%20wind%20effect%2C%20artistic%20manga%20style%20with%20painterly%20texture%2C%20warm%20golden%20lighting%20from%20setting%20sun&width=800&height=500&seq=carousel-02-2026&orientation=landscape",
    title: '奇幻冒险盛宴',
    desc: '热血战斗与宏大世界观，沉浸式追更停不下来',
    tag: '日漫经典',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20manga%20style%20illustration%20of%20school%20corridor%20with%20warm%20afternoon%20sunlight%20streaming%20through%20windows%2C%20gentle%20golden%20hour%20atmosphere%2C%20peaceful%20everyday%20scene%2C%20soft%20shadows%20and%20warm%20cream%20tones%2C%20nostalgic%20Japanese%20aesthetic%2C%20clean%20and%20serene%20composition&width=800&height=500&seq=carousel-03-2026&orientation=landscape",
    title: '悬疑推理专场',
    desc: '烧脑剧情层层递进，每一话都藏着关键线索',
    tag: '推理佳作',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20manga%20illustration%20of%20rain%20soaked%20city%20street%20at%20night%2C%20warm%20neon%20reflections%20on%20wet%20pavement%2C%20atmospheric%20urban%20scene%2C%20moody%20but%20warm%20amber%20street%20lights%2C%20artistic%20Japanese%20noir%20aesthetic%2C%20dramatic%20composition%20with%20depth%20and%20atmosphere&width=800&height=500&seq=carousel-04-2026&orientation=landscape",
    title: '国漫崛起力作',
    desc: '原创国产漫画精品，画风与故事双双在线',
    tag: '国漫推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题推荐
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            精选四大追更专题，发现最对胃口的连载佳作
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}